import { forwardRef, type SVGProps } from 'react';

export const Delete = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g fill="currentColor">
      <path d="M19.452 7.5H4.547a.5.5 0 0 0-.5.545l1.287 14.136A2 2 0 0 0 7.326 24h9.347a2 2 0 0 0 1.992-1.819L19.95 8.045a.5.5 0 0 0-.129-.382.5.5 0 0 0-.369-.163zm-9.2 13a.75.75 0 0 1-1.5 0v-9a.75.75 0 0 1 1.5 0zm5 0a.75.75 0 0 1-1.5 0v-9a.75.75 0 0 1 1.5 0z" />
      <path d="M22 4h-4.75a.25.25 0 0 1-.25-.25V2.5A2.5 2.5 0 0 0 14.5 0h-5A2.5 2.5 0 0 0 7 2.5v1.25a.25.25 0 0 1-.25.25H2a1 1 0 0 0 0 2h20a1 1 0 0 0 0-2zM9 3.75V2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v1.25a.25.25 0 0 1-.25.25h-5.5A.25.25 0 0 1 9 3.75z" />
    </g>
  </svg>
));
